<div class="flex flex-col h-full">
  <!-- Page Header -->
  <app-page-header [wrap]="!quickstartActive">
    @if (quickstartActive) {
      <!-- Topbar im Quickstart-Modus (Figma 13939-15849): Name des myChecks und Übernehmen. Suche, Filter, Anlegen und der Eigene/BIC-Umschalter
           führen hier ins Leere und entfallen deshalb. Feste Standardhöhe (72px), kein Untertitel. -->
      <span class="flex-1 min-w-0 truncate text-xl font-medium">myCheck - {{ quickstartRulesetName }}</span>
      <div class="flex flex-row items-center gap-4">
        <bic-button (onClick)="applyQuickstart()" [disabled]="applyingQuickstart" [loading]="applyingQuickstart">
          Übernehmen
        </bic-button>
      </div>
    } @else {
    <app-my-check-tabs active="own"></app-my-check-tabs>
    <div class="flex flex-row flex-wrap items-center justify-end gap-4">
      <!-- Suchleiste: schrumpft ab hier flexibel statt fix, damit unterhalb von 1760px (siehe
           restliche Buttons dieser Zeile) noch Platz für die Icon-only-Aktionen bleibt. -->
      <div class="flex-1 min-w-[140px] max-w-[268px]">
        <bic-input (valueChange)="searchQuery = $event"
                   [iconStart]="faMagnifyingGlass"
                   [placeholder]="'Suche nach...'"
                   [value]="searchQuery">
        </bic-input>
      </div>
      <!-- Filter nach Prüfregeltyp -->
      <app-bic-filter (filtersChange)="onFiltersChange($event)" [filtersConfig]="filterConfig"
                      labelClass="bic-btn-label--compact"></app-bic-filter>
      <!-- Button-Label bleibt statisch; pro Kriterium ein Pfeil-Paar für beide Sortierrichtungen.
           Unterhalb 1760px (siehe Breakpoint-Messung) reicht der Platz nicht mehr für alle
           Textlabels dieser Zeile in einer Reihe – ab da nur noch Icon + Tooltip. -->
      <bic-button [bicDropdownTrigger]="sortDropdown" buttonType="white" tooltip="Sortieren" tooltipDirection="bottom">
        <fa-icon [icon]="faArrowDownWideShort" iconLeft></fa-icon>
        <span class="bic-btn-label--compact">Sortieren</span>
      </bic-button>
      <bic-dropdown #sortDropdown [dropdownPlacement]="'bottom-end'" class="contents">
        <div class="w-[200px] py-1">
          @for (opt of sortFieldOptions; track opt.field) {
            <div class="flex flex-row items-center justify-between gap-3 px-3 py-1 hover:bg-gray-50">
              <span class="text-sm text-gray-900">{{ opt.label }}</span>
              <div class="flex flex-row items-center gap-0.5">
                <button (click)="applySort(opt.field, 'asc')"
                        [class]="'p-0.5 hover:text-[#000] ' + (sortField === opt.field && sortDirection === 'asc' ? 'text-[#000]' : 'text-gray-300')"
                        [tooltip]="opt.ascLabel" tooltipDirection="top"
                        type="button">
                  <fa-icon [icon]="faArrowUpWideShort" class="text-sm"></fa-icon>
                </button>
                <button (click)="applySort(opt.field, 'desc')"
                        [class]="'p-0.5 hover:text-[#000] ' + (sortField === opt.field && sortDirection === 'desc' ? 'text-[#000]' : 'text-gray-300')"
                        [tooltip]="opt.descLabel" tooltipDirection="top"
                        type="button">
                  <fa-icon [icon]="faArrowDownWideShort" class="text-sm"></fa-icon>
                </button>
              </div>
            </div>
          }
        </div>
      </bic-dropdown>
      <bic-button (onClick)="openFavoritesPopup()" buttonType="white" tooltip="Favoriten"
                  tooltipDirection="bottom">
        <fa-icon [icon]="faStar" iconLeft></fa-icon>
        <span class="bic-btn-label--compact">Favoriten</span>
      </bic-button>
      @if (canCreateRuleset) {
        <bic-button (onClick)="openCreatePopup()" buttonType="white" tooltip="Neuer myCheck" tooltipDirection="bottom">
          <fa-icon [icon]="faPlus" iconLeft></fa-icon>
          <span class="bic-btn-label--compact">Neuer myCheck</span>
        </bic-button>
      } @else if (canManageRules) {
        <span [tooltip]="templateQuotaTooltip" tooltipDirection="bottom">
          <bic-button [disabled]="true" buttonType="white">
            <fa-icon [icon]="faPlus" iconLeft></fa-icon>
            <span class="bic-btn-label--compact">Neuer myCheck</span>
          </bic-button>
        </span>
      } @else {
        <span [tooltip]="noManageRulesTooltip" tooltipDirection="bottom">
          <bic-button [disabled]="true" buttonType="white">
            <fa-icon [icon]="faPlus" iconLeft></fa-icon>
            <span class="bic-btn-label--compact">Neuer myCheck</span>
          </bic-button>
        </span>
      }
    </div>
    }
  </app-page-header>

  <!-- Content -->
  @if (quickstartActive) {
    <!-- myCheck Quickstart: eingebetteter Chat wie bisher – bewusst nicht die Floating-Sidebar,
         und bewusst nicht im Editor, der bis zum Abschluss nur leere Felder zeigen würde. -->
    <div class="flex-1 flex flex-col overflow-hidden p-6 gap-4">
      @if (quickstartInitializing) {
        <div class="flex flex-1 justify-center items-center">
          <div class="flex flex-row items-center gap-2">
            <fa-icon [icon]="faSpinnerThird" class="text-gray-500 animate-spin text-svg-16"></fa-icon>
            <span class="text-sm font-medium text-gray-500">myCheck Quickstart wird gestartet...</span>
          </div>
        </div>
      } @else {
        @if (chatService.mycheckSeries) {
          <!-- Mehrere myChecks in einem Quickstart (BIC-Backend#189): Stand je myCheck, Anhalten/Fortsetzen. -->
          <div class="w-full flex justify-center">
            <app-mycheck-series-status class="w-full max-w-[1000px]"
                                       [series]="chatService.mycheckSeries"
                                       [projectId]="$safeNavigationMigration(stateConfigService.selectedProject?.id)"
                                       [paused]="chatService.mycheckSeriesPaused"
                                       [busy]="chatService.session('mycheck').isBotThinking"
                                       (pause)="chatService.pauseMycheckSeries()"
                                       (resume)="chatService.resumeMycheckSeries()"></app-mycheck-series-status>
          </div>
        }
        <div class="flex-1 overflow-y-auto flex justify-center">
          <div class="w-full max-w-[1000px]">
            <app-chatBIC-view class="w-full h-full" surface="mycheck"></app-chatBIC-view>
          </div>
        </div>
        <div class="w-full flex justify-center">
          <app-message-view class="w-full max-w-[1000px]" surface="mycheck"></app-message-view>
        </div>
      }
    </div>
  } @else {
  <div class="flex flex-col gap-4 p-6 overflow-y-auto flex-1">
    @if (templateQuotaExhausted && canManageRules) {
      <div class="flex flex-row items-start gap-2 rounded-lg border border-yellow-200 bg-yellow-50 px-4 py-3 text-sm text-yellow-900">
        <fa-icon [icon]="faCircleInfo" class="mt-0.5 shrink-0 text-sm text-yellow-700"></fa-icon>
        <span>
          Ihr Abo erlaubt <span class="font-medium">{{ templateQuota?.limit ?? 0 }}</span> myCheck-Vorlagen
          und ist ausgeschöpft. Löschen Sie eine bestehende Vorlage oder erweitern Sie Ihr Abo im Shop.
        </span>
      </div>
    }
    @if (loading) {
      <!-- Skeleton-Loading State -->
      <div class="grid grid-flow-row gap-6 w-full"
           style="grid-template-columns: repeat(auto-fill, minmax(364px, 1fr));">
        @for (i of [1, 2, 3, 4]; track i) {
          <app-skeleton-card></app-skeleton-card>
        }
      </div>
    } @else if (activeRulesets.length === 0) {
      <app-empty-state [icon]="faClipboardList" [message]="emptyStateMessage" class="flex-1">
        @if (canCreateRuleset) {
          <bic-button (onClick)="openCreatePopup()" buttonType="white">
            <fa-icon [icon]="faPlus" iconLeft></fa-icon>
            Neuer myCheck
          </bic-button>
        } @else {
          <span [tooltip]="canManageRules ? templateQuotaTooltip : noManageRulesTooltip" tooltipDirection="top">
            <bic-button [disabled]="true" buttonType="white">
              <fa-icon [icon]="faPlus" iconLeft></fa-icon>
              Neuer myCheck
            </bic-button>
          </span>
        }
      </app-empty-state>
    } @else {
      <div class="grid grid-flow-row gap-6 w-full"
           style="grid-template-columns: repeat(auto-fill, minmax(364px, 1fr));">
        @for (ruleset of activeRulesets; track ruleset.id) {
          <app-ruleset-card
            (delete)="onDeleteRequested($event)"
            (duplicate)="onDuplicateRequested($event)"
            (execute)="onExecuteRuleset($event)"
            (exportPackage)="onExportRequested($event)"
            (createCheckRun)="onCreateCheckRunRequested($event)"
            (open)="onOpenRuleset($event)"
            (provideGlobally)="onProvideGloballyRequested($event)"
            (share)="onShareRequested($event)"
            (unshareHere)="onUnshareHereRequested($event)"
            (transferOwnership)="onTransferOwnershipRequested($event)"
            [catalogSubmission]="catalogSubmissionFor(ruleset)"
            [catalogSubmissionAllowed]="catalogSubmissionAllowed"
            [preparingRun]="preparingRunRulesetId === ruleset.id"
            [ruleset]="ruleset"></app-ruleset-card>
        }
      </div>
    }
  </div>
  }

</div>

<!-- Popups -->
@if (createCheckRunFor) {
  <app-create-check-run-prompt
    (closed)="closeCreateCheckRun()"
    (confirmed)="onCreateCheckRunConfirmed($event)"
    [hint]="'„' + createCheckRunFor.name + '\u201c ist im Prüflauf als vordefinierte Regelauswahl gesetzt. Dateiauswahl und Bericht legen Sie anschließend im Builder fest.'"
    [initialName]="createCheckRunFor.name"
    [saving]="creatingCheckRun">
  </app-create-check-run-prompt>
}

@if (showFavoritesPopup) {
  <app-favorites-prompt (closed)="onFavoritesClosed()"></app-favorites-prompt>
}

@if (popupState === 'prompt') {
  <app-create-ruleset-prompt
    (closed)="onPromptClosed()"
    (created)="onPromptCreated($event)">
  </app-create-ruleset-prompt>
}

<!-- Ergebnis eines Imports bzw. Fehler eines Ex-/Imports (gemeinsam mit dem Adminbereich) -->
@if (importResult || importErrors.length > 0) {
  <app-ruleset-import-feedback
    (closed)="closeImportFeedback()"
    (open)="openImportedRuleset()"
    [errors]="importErrors"
    [result]="importResult"></app-ruleset-import-feedback>
}

@if (rulesetToDelete) {
  <bic-popup (close)="cancelDelete()" [hasBackdrop]="true" customClass="w-[560px]"
             title="myCheck löschen?">
    <div bicPopupContent class="flex flex-col gap-4">
      <span class="font-normal">Möchten Sie den myCheck „{{ rulesetToDelete.name }}" wirklich löschen?<br><br>
        Diese Aktion kann nicht rückgängig gemacht werden.</span>
      <app-rule-usage-warning [loading]="deleteUsagesLoading" [usages]="deleteUsages"></app-rule-usage-warning>
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
      <bic-button (onClick)="cancelDelete()" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="confirmDelete()" [disabled]="deleteUsagesLoading" buttonType="primary">Löschen</bic-button>
    </div>
  </bic-popup>
}

<!-- myCheck mit anderen Projekten der Organisation teilen -->
@if (projectShareRuleset && currentProjectId) {
  <app-share-with-projects-prompt
    (closed)="projectShareRuleset = null"
    (saved)="onProjectSharesSaved()"
    [checkName]="projectShareRuleset.name"
    [definitionId]="projectShareRuleset.id"
    [entity]="'ruleset'"
    [projectId]="currentProjectId">
  </app-share-with-projects-prompt>
}

<!-- Geteilter myCheck: Eigentümer ändern bzw. löschen (Besitz übergeben / überall löschen) -->
@if (ownershipRuleset && currentProjectId) {
  <app-project-ownership-prompt
    (closed)="ownershipRuleset = null"
    (done)="onOwnershipDone()"
    [entity]="'ruleset'"
    [itemId]="ownershipRuleset.id"
    [itemName]="ownershipRuleset.name"
    [mode]="ownershipMode"
    [projectId]="currentProjectId"
    [ruleset]="ownershipRuleset">
  </app-project-ownership-prompt>
}

<!-- Geteilten myCheck aus diesem Projekt entfernen (Bestätigung) -->
@if (unshareHereRuleset) {
  <bic-popup (close)="cancelUnshareHere()" [hasBackdrop]="true" customClass="w-[560px] h-fit"
             title="Aus diesem Projekt entfernen?">
    <div bicPopupContent class="flex flex-col">
      <span class="font-normal">Möchten Sie den geteilten myCheck „{{ unshareHereRuleset.name }}" aus diesem Projekt entfernen?<br><br>
        Er bleibt in seinem Eigentümerprojekt bestehen. Prüfläufe in diesem Projekt verwenden ihn danach nicht mehr; bereits erstellte Berichte bleiben erhalten.</span>
    </div>
    <div bicPopupButtonGroup class="flex flex-row w-full justify-end items-center gap-4">
      <bic-button (onClick)="cancelUnshareHere()" [disabled]="unsharingHere" buttonType="white">Abbrechen</bic-button>
      <bic-button (onClick)="confirmUnshareHere()" [loading]="unsharingHere" buttonType="primary">Entfernen</bic-button>
    </div>
  </bic-popup>
}

<!-- Zentral bereitstellen (Adminfunktion) = Einreichung in den Katalog – gemeinsamer Dialog mit den Prüfläufen -->
@if (provideTarget) {
  <app-catalog-submission-prompt
    (closed)="closeProvideDialog()"
    (submitted)="onCatalogSubmitted($event)"
    [itemName]="provideTarget.name"
    [itemType]="provideTarget.type"
    [projectId]="currentProjectId"
    [sourceId]="provideTarget.id">
  </app-catalog-submission-prompt>
}
